namespace Newtonsoft.ViewModels.Newsletter {
    export class NewsletterViewModel {
        emailAddress = ko.observable<string>().extend({
            required: {
                params: true,
                message: "Email address is required"
            },
            email: true
        });
        complete = ko.observable<boolean>(false);
        busy = ko.observable<boolean>(false);
        message = ko.observable<string>();
        validation: any;
        tokenHeader = ko.observable<string>();

        constructor(tokenHeader) {
            this.tokenHeader(tokenHeader);
            this.validation = ko.validatedObservable(this);
        }

        async subscribe() {
            if (!this.validation.isValid()) {
                this.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                emailAddress: this.emailAddress()
            });

            this.busy(true);

            try {
                const response = await fetch("/api/newsletter/subscribe", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    this.message("You rock! Your subscription has been confirmed.");
                    this.complete(true);
                } else {
                    await Newtonsoft.handleFailure(this, response);
                }
            } finally {
                this.busy(false);
            }
        }
    }
}
